export enum ChannelTypes {
  text = 'text',
  favorites = 'favorites',
  recents = 'recents',
  popular = 'popular',
  recommendations = 'recommendations',
}
